import './version';
export * from '@fluentui/utilities';
//# sourceMappingURL=Utilities.js.map